import { createFileRoute } from "@tanstack/react-router";
import { SparklesIcon } from "lucide-react";
import { AiActionModelsPanel } from "@/components/admin/ai-action-models-panel";
import { AiSettingsPanel } from "@/components/admin/ai-settings-panel";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/ai")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminAiPage,
});

function AdminAiPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <SparklesIcon className="size-3.5" />
          Configuration
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">AI</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Select the AI provider and model used across document generation. Supports Anthropic
            (Claude), OpenAI, Gemini, and OpenRouter.
          </p>
        </div>
      </header>

      <AiSettingsPanel />
      <AiActionModelsPanel />
    </div>
  );
}
